import Button from "@mui/material/Button";
import { Box, Stack } from "@mui/system";
import {
  Alert,
  Autocomplete,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import FormatListNumberedIcon from "@mui/icons-material/FormatListNumbered";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  getCurrentUtcTime,
  handleChangeHelper,
  handleFormatHelper,
} from "../../DataStoreHelpers/dataStoreHelpers";
import {
  setEditQueryFormData,
  // setQueryContentSingle,
} from "../../../../../features/dataStoreReqSlice";
import Editor from "react-simple-code-editor";
import Prism from "prismjs";
import "prismjs/components/prism-sql";
import "prismjs/themes/prism.css"; // or your theme
import SimpleBackdrop from "../../../../BackDrop/BackDrop";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { selectUserData } from "../../../../../features/userSlice";
const EditInfo = () => {
  const databaselist = [
    { label: "Google Bigquery", value: "google_bq" },
    { label: "MySQL", value: "central" },
  ];

  const dispatch = useDispatch();

  const { queryContentSingle, hasError, editLoading, queryModules } =
    useSelector((state: any) => state.dataStoreReq);
  const formData = useSelector(
    (state: any) => state.dataStoreReq.editQueryFormData
  );
  const handleChange = (key: string, value: any) => {
    handleChangeHelper(dispatch, setEditQueryFormData, key, value);
    // dispatch(setQueryContentSingle({ ...queryContentSingle, [key]: value }));
  };

  const handleFormat = () => {
    handleFormatHelper(formData.query, (updatedSql) => {
      handleChange("query", updatedSql);
    });
  };

  useEffect(() => {
    if (queryContentSingle) {
      dispatch(setEditQueryFormData(queryContentSingle));
    }
  }, [queryContentSingle, dispatch]);

  const highlight = (code: string) => {
    const language = queryContentSingle && Prism.languages.sql;
    if (!language) return code; // fallback to plain text if not loaded
    return Prism.highlight(code, language, "sql");
  };
  const requestTypeList = ["Business Insight", "Data Anomaly", "Report"];
  const userEmail = useSelector(selectUserData)?.data?.user_details?.email;

  useEffect(() => {
    if (!formData.modified_by) {
      handleChange("modified_by", userEmail);
    }

    if (!formData.modified) {
      handleChange("modified", getCurrentUtcTime());
    }

    if (queryContentSingle?.created && !formData.created) {
      handleChange("created", queryContentSingle.created);
    }

    if (queryContentSingle?.created_by && !formData.created_by) {
      handleChange("created_by", queryContentSingle.created_by);
    }
    // eslint-disable-next-line
  }, [queryContentSingle, userEmail]); // ✅ run only when data loads

  return (
    <Box>
      {editLoading ? (
        <SimpleBackdrop />
      ) : (
        <>
          <Grid container spacing={2} mt={2}>
            <Grid size={4}>
              <TextField
                id="outlined-required"
                label="Query Name"
                fullWidth
                size="small"
                color="secondary"
                placeholder="How you like the Query to be called"
                value={formData.name}
                onChange={(e) => handleChange("name", e.target.value)}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            </Grid>
            <Grid size={4}>
              <Autocomplete
                disablePortal={false}
                options={databaselist}
                value={
                  formData.database === "google_bq"
                    ? databaselist[0]
                    : databaselist[1]
                }
                onChange={(_, newValue) =>
                  handleChange("database", newValue?.value ?? "")
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Please select a database from the list"
                    label="Database"
                    fullWidth
                    size="small"
                    color="secondary"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={4}>
              <Autocomplete
                disablePortal={false}
                options={requestTypeList}
                value={formData.type}
                onChange={(_, newValue) => handleChange("type", newValue)}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    placeholder="Please select request type from the list"
                    label="Request Type"
                    fullWidth
                    size="small"
                    color="secondary"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={2}>
            {/* Modules */}
            <Grid size={6}>
              <Autocomplete
                multiple
                size="small"
                options={queryModules}
                value={formData.modules || []}
                onChange={(_, newValue) => handleChange("modules", newValue)}
                renderInput={(params) => (
                  <TextField
                    required
                    {...params}
                    placeholder="Please select a module from the list"
                    label="Modules"
                    fullWidth
                    size="small"
                    color="secondary"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                )}
              />
            </Grid>

            {/* Confluence URL + Icon */}
            <Grid size={6}>
              <Grid container spacing={1} alignItems="center">
                <Grid size={11}>
                  <TextField
                    id="outlined-required"
                    label="Confluence URL"
                    fullWidth
                    size="small"
                    color="secondary"
                    value={formData.confluence_url}
                    onChange={(e) =>
                      handleChange("confluence_url", e.target.value)
                    }
                    placeholder="Confluence URL"
                    slotProps={{
                      inputLabel: {
                        shrink: true,
                      },
                    }}
                  />
                </Grid>
                <Grid size={1}>
                  <IconButton
                    color="secondary"
                    disabled={!formData.confluence_url?.trim()}
                    onClick={() => {
                      if (formData.confluence_url) {
                        window.open(formData.confluence_url, "_blank");
                      }
                    }}
                  >
                    <OpenInNewIcon />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container spacing={2} mt={2}>
            <Grid size={12}>
              <TextField
                color="secondary"
                size="medium"
                fullWidth
                value={formData.description}
                onChange={(e) => handleChange("description", e.target.value)}
                id="outlined-multiline-static"
                label="Query Description"
                multiline
                rows={4}
                placeholder="What is the purpose of this SQL query"
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  },
                }}
              />
            </Grid>
            <Grid size={12}>
              <div
                style={{
                  position: "relative",
                  display: "inline-block",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: "-8px",
                    left: "8px",
                    background: "#f5f5f5",
                    padding: "2px 6px",
                    fontSize: "12px",
                    borderRadius: "4px",
                    zIndex: 1,
                  }}
                >
                  Request SQL
                </div>

                <Box
                  sx={{
                    height: "300px", // starting height
                    minHeight: "300px", // cannot go smaller than this
                    width: "100%", // always full width
                    resize: "vertical", // only allow vertical resize
                    overflow: "auto", // keep scrollbars if content overflows
                    border: "1px solid #ccc",
                    borderRadius: "4px",
                  }}
                >
                  <Editor
                    value={formData.query}
                    onValueChange={(val) => handleChange("query", val)}
                    highlight={highlight}
                    padding={10}
                    style={{
                      fontFamily: '"Fira code", "Fira Mono", monospace',
                      fontSize: 14,
                      minHeight: "100%",
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                    }}
                  />
                </Box>

                {hasError && (
                  <Alert severity="error" sx={{ mt: 2 }}>
                    Something went wrong. Please check your inputs and SQL query
                    for errors, then try again.
                  </Alert>
                )}
              </div>

              <Stack
                spacing={1}
                direction="row"
                alignItems="center"
                mt={1}
                gap={2}
              >
                <Button
                  color="secondary"
                  variant="outlined"
                  endIcon={<FormatListNumberedIcon />}
                  onClick={handleFormat}
                >
                  Format
                </Button>
                <Stack>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px" }}
                    color="#00000099"
                  >
                    Do not use snippets or comments in the SQL syntax. Do not
                    use constructions like FORMAT(\“%d\“,
                    CAST(floor(additional_2)) (or other constructions using
                    \“%d\")).
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
          </Grid>
        </>
      )}
    </Box>
  );
};

export default EditInfo;
